module.exports = __webpack_public_path__ + "img/cross_green.7b265071.svg";